import { Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ListViewController } from '@commoncore/controller/ListViewController';
import { PreviewImplementation } from '@commoncore/implementation/PreviewImplementation';
import { ClapprImplementation } from '@commoncore/implementation/clappr-implementation';
import { GlobalService } from '@commoncore/services/global.service';
import { PingService } from '@commoncore/services/ping.service';
import { MultiSelectLibrary } from '@commoncore/utils/MultiSelectUtil';
import { AppEvents } from '@commoncore/utils/app-events';
import { AudiosController } from '@mainrepo/app/core/controller/AudiosController';
import lottie, { AnimationItem } from "lottie-web";
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'lib-audioclappr',
  templateUrl: './audioclappr.component.html',
  styleUrls: ['./audioclappr.component.scss'],
})
export class AudioclapprComponent implements OnInit, OnDestroy {

  public clapprImpl: ClapprImplementation;
  @Input() previewDirection:any="";
  private audioplayer:any;
  public songtitle:string;
  private showLoader: boolean = false;
  public universalService:any;
  public controller:any;
  public listImpl:any;
  public listController:any;
  public listService:any;
  public modules : any;
  public contextMenuService:any;
  public initialSelection:any;
  public audioCount:any = 0;
  loggerService: any;
  implRef: any;
  multiSelect: any;
  containerHeightCalc:any;
  router:any;
  ppfToken:any;
  previewImpl: any;
  // impl: any;
  pingService: any;
 
  @Output('previewError') isErrorInPreviewing:EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private globalService:GlobalService) {
    this.universalService = globalService.getUniversalServiceRef();
    this.listService = globalService.getListServiceRef();
    this.contextMenuService = globalService.getContextMenuServiceRef();
    this.loggerService = globalService.getLoggerServiceRef();
    this.multiSelect = MultiSelectLibrary.getInstance(globalService);
    this.containerHeightCalc = globalService.getContainerHeightCalculatorService();
    this.router = this.globalService.getRouterRef();
    this.pingService = PingService.getInstance(globalService);
  }

  @HostListener('window:resize', [])resize(){
    var self = this;
    this.universalService.checkDeviceType();
    $('.audioCntnr .player-poster[data-poster] .play-wrapper[data-poster] svg path').addClass('hide')
    $('#audio-media-content [data-player]').height($('#imgover').outerHeight() - ($('.itemListContainer').height()));
    let height =$('.desktopAudioBox').height() + 160;
    let mob_height = $('.audioPosterMobile').height() + 75;
    if(self.universalService.isMobileDevice){
      $('#audio_player [data-player]').height(mob_height.toString());
      $('#audio_player').height(mob_height.toString());
      self.contextMenuService.contextMenuMobileService.getSingleFileContextMenu(false);
    }else{
      $('#audio_player [data-player]').height(height.toString());
    }

    self.clapprImpl.pauseAudio();
    if(!this.universalService.isMobileDevice) {
      setTimeout(() => {
        if(this.listService.audioPreviewOptions.api != undefined) {
          this.listService.audioPreviewOptions.api.setRowData(this.listService.rowData);
        }
      }, 1000);
    }
  }

  ngOnInit(): void {
    var self = this;
    this.previewImpl = PreviewImplementation.getInstance(this.globalService);
    this.clapprImpl = this.getClapprImplRef();
    this.universalService.audioClapperRunning = true
    if(this.universalService.activeRepo == 'main'){
      this.controller = AudiosController.getInstance(this.globalService);
      this.controller.setEnvObjects(this.globalService);
      if(this.router.url.includes("privatefolder")){
         this.listService.getPPFToken();
      }
       if(!this.universalService.isMobileDevice && (this.universalService.currentTab == 'audio' || this.universalService.showFullViewAudioPlayer ) 
         ){
         this.listController = ListViewController.getInstance(this.globalService);
         this.listImpl = this.listController.listViewImplementation;
         this.universalService.selectedAudioFile = this.universalService.selectedFile
         this.getRowAndCellStyles();
       }
    }
    this.clapprImpl.previewNotAvailable = false
    // stop the audio if already running 
    /*if(this.universalService.player!=undefined && this.universalService.player!=null && !this.universalService.showFullViewAudioPlayer){
      this.universalService.player.pause();
      this.universalService.player.stop();
      this.universalService.player.destroy();
    }*/
    this.clapprImpl.openClappr();
    this.universalService.selectedAudioFile = this.universalService.selectedFile;
    setTimeout(()=>{
      if(!this.universalService.isMobileDevice && this.clapprImpl.audioPlaying){
        lottie.loadAnimation({
          container: document.getElementById("lottie_"+this.universalService.selectedAudioFile.objectKey), // required
          path: 'assets/music_animation.json', // required
          renderer: 'svg',
        })
      }
    },900)
  }

  ngAfterViewInit(): void {
    var self = this;
    AppEvents.previewErrorEvent.subscribe(response => {
      if(response["errorValue"] &&  response["tab"] == 'audio'){
        this.previewErrorCheck("error");
      }else{
        this.isErrorInPreviewing.emit(true);

      }
    })

    AppEvents.optionSelected.subscribe(event => {
      if(event["audioFileUpdated"]){
        self.previewImpl.fileForPreview = self.universalService.selectedFile;
        self.universalService.selectedPreviewFile = self.universalService.selectedFile;
        this.contextMenuService.decideContextMenuItems();
        // this.universalService.selectedNodes = [self.universalService.selectedFile];
        
        // if(this.router.url.includes('/privatefolder'))
        //   self.contextMenuService.getContextMenuForFileEntityPreviewInPrivateFolder(self.universalService.selectedFile)
        // else
        //   self.contextMenuService.getContextMenuForFileEntityPreview(self.universalService.selectedFile);
      }
    });
  }

  previewErrorCheck(errorValue:String){
    if(errorValue == "error" && this.clapprImpl){
      this.clapprImpl.previewNotAvailable = true;
    }
  }

  options: AnimationOptions = {
    path: 'assets/bg_animation.json',
  };

  eqioptions: AnimationOptions = {
    path : 'assets/music_animation.json'
  };
  animationCreated(animationItem: AnimationItem): void {
  
  }

  getClapprImplRef(){
    //return new ClapprImplementation(this.globalService)
    return ClapprImplementation.getInstance(this.globalService)

  }

  

  getBackgroundImageUrl(){
    return 'url('+this.clapprImpl.getAudioPosterUrl()+')';
  }

  
  ngOnDestroy(){
    this.clapprImpl = null;
    this.audioplayer = null;
    this.songtitle = null;
    this.showLoader = null;
    this.universalService.audioClapperRunning = false;
    this.pingService.clearInterval();
  }


  onRowSelected(event){ 
    /**
     * ag-grid calls the "onRowSelected" event twice, once for the row being selected, and once for the row being unselected.
     * This was creating multiple calls to audio player.
     * Below check resolves that 
     **/ 
    $('.audiosList .ag-row-selected').removeClass("ag-row-selected");
    if (event.node.selected) {
      $('.audiosList').find("[row-index=" + event.rowIndex + "]").addClass("ag-row-selected");
      this.clapprImpl.previewNotAvailable = false;
    }
    if (!event.node.selected) {
      $('.audiosList').find("[row-index="+event.rowIndex+"]").removeClass("audioNameSelected");
      $('.audiosList').find("[row-index="+this.clapprImpl.selectedIndexValue+"]").addClass("ag-row-selected");
      return;
    }
    // $('.ag-row').css("background-color","#f7f7f7");
    this.universalService.slectedRowId = event.rowIndex;
    this.universalService.songPosTime = 0;
    if(this.initialSelection != undefined) {
      var initialId= this.initialSelection.id;
      $('.audiosList').find("[row-index="+initialId+"]").css("background-color", "");
      this.initialSelection = undefined;
    }
    if(this.clapprImpl.selectedIndexValue!=-1){
      $('.audiosList').find("[row-index="+this.clapprImpl.selectedIndexValue+"]").removeClass("audioNameSelected");
      if (!event.node.selected) {
        $('.audiosList').find("[row-index="+this.clapprImpl.selectedIndexValue+"]").addClass("ag-row-selected");
      }
    }
    this.clapprImpl.selectedIndexValue=event.rowIndex
    this.universalService.audioListIndexOnPreview=this.clapprImpl.selectedIndexValue;

    //this.initialSelection = event.node;

    this.universalService.playAudioFromStart = true;
    if(this.universalService.player!=undefined && this.universalService.player!=null){
      this.universalService.player.pause();
      this.universalService.player.stop();
      this.universalService.player.destroy();
    // this.clapprImpl.audioplayer.stop();
    // this.clapprImpl.audioplayer.destroy();
    }
    if(this.clapprImpl.audioplayer) {
      this.clapprImpl.pauseAudio();
      this.clapprImpl.audioplayer.stop();
      this.clapprImpl.audioplayer.destroy();
    }
    this.universalService.openMoreOptions = false;
    this.universalService.selectedNodes = this.listService.audioPreviewOptions.api.getSelectedRows();
    this.universalService.selectedFile = this.universalService.selectedNodes[0]["FullObject"]; 
    this.universalService.selectedAudioFile = this.universalService.selectedFile
    if(this.universalService.showPreview)
      this.universalService.selectedPreviewFile = this.universalService.selectedFile;
    this.loggerService.log("event",event,this.universalService.selectedFile);
    this.contextMenuService.decideContextMenuItems();
    this.clapprImpl.openClappr();
    $("#audios-list-ag-grid").find('.agGridEqualizer span div').empty();
    setTimeout(()=>{
      if(!this.universalService.isMobileDevice && this.clapprImpl.audioPlaying){
        lottie.loadAnimation({
          container: document.getElementById("lottie_"+this.universalService.selectedAudioFile.objectKey), // required
          path: 'assets/music_animation.json', // required
          renderer: 'svg',
        })
      }
    },500)
  }
  
  playfromPlayList(index){ 
    let selectedSong =  this.universalService.mobilePlayList[index]
    if(selectedSong.objectKey == this.universalService.selectedFile.objectKey){
      setTimeout(() => {
        this.universalService.showLoader = false;
      }, 500);
      return;
    }
    

    setTimeout(()=>{
      this.universalService.selectedNodes[0] = selectedSong;
      this.clapprImpl.pauseAudio();
      if(this.universalService.player!=undefined && this.universalService.player!=null){
      this.clapprImpl.audioplayer.stop();
      this.clapprImpl.audioplayer.destroy();
      }
      this.universalService.openMoreOptions = false;
      this.universalService.selectedFile = this.universalService.selectedNodes[0];
      this.universalService.selectedAudioFile = this.universalService.selectedFile
      this.loggerService.log("event",event,this.universalService.selectedFile);
      this.universalService.songPosTime = 0;
      this.universalService.showAudioWaves = true;
      this.contextMenuService.decideContextMenuItems();
      this.clapprImpl.openClappr();
      this.hidePreviwOptn();
      this.universalService.showLoader = false;
    },500)
  }

  async openMobilePlayList(event){
    event.stopPropagation();
    this.hidePreviwOptn();
    this.universalService.showMobilePlayList = true;
    //this.universalService.showLoader = true;
    this.universalService.showAudioWaves = false;
    this.multiSelect = MultiSelectLibrary.getInstance(this.globalService);
    this.multiSelect.bindMultiSelectLibrary("#preview-modal", "list_info", ".listItem:visible", false,this.universalService.virtualGridEnabled,false);
    this.multiSelect.bindMultiSelectUIevent(".main-wrapper", ".list_file_child");
    // await this.setGlobalCountForfilters();
    await this.setHeightForGrid();
    setTimeout(()=>{
      let element = document.querySelector('.highLightSelectedItem') as any;
      let elementId = '#' + element.id
      $('#audioWrapperId').scrollTop($(elementId).offset().top - 50);
     // this.universalService.showLoader = false;
    },800)
    //this.highlightselectedFile();
  }
  // highlightselectedFile(){
  //   this.universalService.mobilePlayList.forEach(obj => {
  //     if(this.universalService.selectedNodes[0].objectKey == obj.objectKey){
  //       obj["selectedItem"] = true;
  //     }else{
  //       obj["selectedItem"] = false;
  //     }
  //   })
  // }
  setGlobalCountForfilters(){
    this.audioCount = 0;
    this.universalService.summaryData.audio.forEach(obj => {
        this.audioCount = this.audioCount + parseInt(obj.fileCount)
    });
  }
  hidePreviwOptn(){
    var optionCont = document.querySelectorAll('#m-collapsed-modal');
    Array.prototype.forEach.call(optionCont, function (menu) {
      if(window.getComputedStyle(menu).display == 'block'){
          menu.style.display = 'none'
      }else{
        menu.style.display = 'block'
      }
    });
  }
  onMobileScrollDown(event){
    this.controller.onMobileScrollDown();
  }
  closePlayList(){
    this.universalService.showAudioWaves = true;
    this.universalService.showMobilePlayList = false;
    this.hidePreviwOptn();
    this.togglePreviewButtons();
  }
  setHeightForGrid() {
    // this.universalService.showLoader = false;
    var self = this;
    if (self.universalService.isMobileDevice) {
      setTimeout(() => {
        let el = (document.querySelector('.mobilePlaylistCont')) as any;
        let header_el = (document.querySelector('.mob-playlist-header')) as any
        let height = window.innerHeight -  header_el.offsetHeight
        el.style.height = height + 'px';
    }, 1000);
    }
  }
// nextAudio(){
  // this.clapprImpl.fetchFile();
  // var id = this.universalService.selectedFile["objectKey"];
  // var find = this.listService.rowData.find(idx=>idx["objectId"] == id)
  // if(find){
  //   var index = this.listService.rowData.indexOf(find);
  //   if(this.listService.rowData[index+1]){
  //     this.universalService.selectedFile = this.listService.rowData[index+1]["FullObject"];
  //     this.universalService.selectedAudioFile = this.universalService.selectedFile
  //   }else{
  //     this.universalService.selectedFile = this.listService.rowData[0]["FullObject"];
  //     this.universalService.selectedAudioFile = this.universalService.selectedFile
  //   }
  //   this.openClappr();
  // }
  
// }

// prevAudio(){
//   this.clapprImpl.fetchFile();
  // var id = this.universalService.selectedFile["objectKey"];
  // var find = this.listService.rowData.find(idx=>idx["objectId"] == id)
  // if(find){
  //   var index = this.listService.rowData.indexOf(find);
  //   if(this.listService.rowData[index-1]){
  //     this.universalService.selectedFile = this.listService.rowData[index-1]["FullObject"];
  //     this.universalService.selectedAudioFile = this.universalService.selectedFile
  //   }else{
  //     this.universalService.selectedFile = this.listService.rowData[this.listService.rowData.length-1]["FullObject"];
  //     this.universalService.selectedAudioFile = this.universalService.selectedFile
  //   }
  //   this.openClappr();
  // }
// }

songShffle(){
  
    
}
songRepeat(){
  
}

togglePreviewButtons(){
  this.controller.togglePreviewButtons()
}

resetInitial(){
  if(this.initialSelection != undefined) {
    var initialId= this.initialSelection.id;
    $('.audiosList').find("[row-index="+initialId+"]").css("background-color", "");
    this.initialSelection = undefined;
  }
  if(this.clapprImpl.selectedIndexValue!=-1){
    $('.audiosList').find("[row-index="+this.clapprImpl.selectedIndexValue+"]").removeClass("audioNameSelected");
  }
}

skipBack(){
  this.clapprImpl.skipBack()
}

repeatSongs(){
  //this.resetInitial();
  this.clapprImpl.repeatSongs()
}

fetchFile(option){
  this.resetInitial();
  this.clapprImpl.fetchFile(option);
}

playPauseAudio(){
  this.clapprImpl.playPauseAudio()
}

shufflePlay(){
  this.clapprImpl.shufflePlay()
}

skipForward(){
  this.clapprImpl.skipForward()

}

downloadItems(){
  AppEvents.globalObservable.next({"downloadItems": true,"files":this.universalService.selectedAudioFile});
}


getRowClass = params => {
    var id = this.getRowAndCellStyles();
    if (params.node.data.objectId == id) {
      return 'ag-row-selected';
    }
  };


  getRowStyle = params => {
    var self = this;
    var id = this.getRowAndCellStyles();
    if (params.node.data.objectId == id) {
      self.initialSelection = params.node;
      // self.universalService.slectedTowId = self.initialSelection.rowIndex
     //  return { 'background-color': '#0c5273', 'color': '#fff', 'border-radius':'10px'};
      return {'border-radius':'10px'};

    }
   
  };


  onGridReady(params){
    this.listService.audioPreviewOptions.api = params.api;
  }


  getRowAndCellStyles(){
    var self = this;
      var id = this.universalService.selectedNodes[0]["FullObject"] ? this.universalService.selectedNodes[0]["objectId"] : this.universalService.selectedNodes[0]["objectKey"]
      if(id == undefined) {
        id = this.universalService.selectedNodes[0]["objectKey"];
      }
      var index = this.listService.rowData.indexOf(id)
      setTimeout(() => {
        this.listService.audioPreviewOptions.api.ensureNodeVisible(id,index);
      }, 10);
     //  this.listService.audioPreviewOptions.getRowClass = function(params) {
     //   if (params.node.data.objectId == id) {
     //     return 'ag-row-selected';

     //   }
     // }
      // this.listService.audioPreviewOptions.getRowStyle = function(params) {
      //   if (params.node.data.objectId == id) {
      //     self.initialSelection = params.node;
      //     self.universalService.slectedTowId = self.initialSelection.rowIndex
      //    //  return { 'background-color': '#0c5273', 'color': '#fff', 'border-radius':'10px'};
      //     return {'border-radius':'10px'};

      //   }
      // }
      
      return id;
  }

  recalculateHeightsWhenGridIsCompletelyRendered($event){
    var self = this;
    self.containerHeightCalc.calculateHeight('#audios-list-ag-grid',['#preview-modal .modal-header'],15); //negative 72 added to remove top-header from popup
  }

  rowDataUpdated(e){
    this.listService.audioPreviewOptions?.api?.refreshCells({force:true,suppressFlash:true});
  }
}